import React, { useEffect, useRef } from 'react';
import './Article.scss';
import { gsap } from './gsap';
import { createPopper } from '@popperjs/core';
// import playerjs from 'player.js';
import Hero from './Components/Hero/Hero';
import Hero2 from './Components/Hero/Hero2';
import Header from './Components/common-header/Header';
import Footer from './Components/common-footer/Footer';
// import AudioPlayer from './Components/AudioPlayer/AudioPlayer';
import InlinePhoto from './Components/Photos/InlinePhoto';
import FullWidthPhoto from './Components/Photos/FullWidthPhoto';
import FullWidthVideo from './Components/Photos/FullWidthVideo';
import InlineVideo from './Components/Photos/InlineVideo';
import Chapter1 from './Components/Chapters/Chapter1';
import Chapter2 from './Components/Chapters/Chapter2';
import Chapter3 from './Components/Chapters/Chapter3';
import Chapter4 from './Components/Chapters/Chapter4';
import Chapter5 from './Components/Chapters/Chapter5';
import Chapter6 from './Components/Chapters/Chapter6';
import Chapter7 from './Components/Chapters/Chapter7';
import contents from './contents';
import RelatedContents from './Components/RelatedContents/RelatedContents';
// import CtaButton from './Components/CtaButton/CtaButton';
import Reference from './Components/Reference/Reference';

//for fullWidth Photos
import fullbleedPhoto1 from './Assets/fullbleedPhoto1.jpg';

function Article({ heroBackgroundType, inlinePhotoSize, logoPlacement }) {
  //below states are for the audio player placement. See README for detail.

  // const [currentHeight, setCurrentHeight] = useState(window.innerHeight); //screen height
  // const [removeGap, setRemoveGap] = useState(false); //true if gap needs to be removed (see README)

  //create refs for each section if you want to add page transition of photo covering the prev. section on scroll

  //create refs for photos here if you want to add scale animation on scroll
  const inline1 = useRef();
  const inline2 = useRef();
  const inline3 = useRef();
  const inline4 = useRef();
  const allPhotosRef = useRef();
  allPhotosRef.current = [inline1, inline2, inline3, inline4]; // put all photo refs in this array

  //create refs for the audio player
  const screenSizeRef = useRef(); //

  const photoSize = inlinePhotoSize !== undefined ? inlinePhotoSize : contents.inlinePhotos.size;

  //creates/shows tooltip element when mouse enters
  const handleMouseEnterTooltip = (e, currentRef) => {
    const content = currentRef.current;
    createPopper(e.target, content, {
      placement: 'bottom',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 5]
          }
        }
      ]
    });
    content.style.visibility = 'visible';
  };

  //hides tooltip element when mouse leaves
  const handleMouseLeaveTooltip = (currentRef) => {
    currentRef.current.style.visibility = 'hidden';
  };

  //creates playerjs instance & listen for play and ended
  // useEffect(() => {
  //   playerRef.current = new playerjs.Player(audioPlayerRef.current);
  //   playerRef.current.on('ready', () => {
  //     playerRef.current.on('play', () => {
  //       setAudioPlayMode(true);
  //     });

  //     playerRef.current.on('ended', () => {
  //       setAudioPlayMode(false);
  //     });
  //   });
  // }, []);

  //adds scale animation to inline photos
  useEffect(() => {
    allPhotosRef.current.forEach((photo) => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: photo.current,
          start: '20% bottom',
          end: 'top center',
          scrub: 1
        }
      });
      tl.to(photo.current, {
        width: '100%',
        height: '100%',
        duration: 3
      });
    });
  }, []);

  // useEffect(() => {
  //   if (!audioPlayMode && removeGap) {
  //     ScrollTrigger.create({
  //       trigger: section2.current,
  //       start: 'top bottom',
  //       pinType: 'fixed',
  //       end: 'top top',
  //       onEnter: () => {
  //         if (section2.current) {
  //           section2.current.style.zIndex = 11;
  //         }
  //       },
  //       invalidateOnRefresh: true,
  //       scrub: 1,
  //       pin: '.audioPlayer',
  //       id: 'audioFixed',
  //       pinSpacer: '.article'
  //     });
  //   }
  // }, [removeGap, audioPlayMode]);

  // //sets up the audio player to be fixed at the top after user interacts with the audio player
  // useEffect(() => {
  //   if (audioPlayMode && !removeGap) {
  //     gsap.to('.audioPlayer', {
  //       scrollTrigger: {
  //         trigger: '.audioPlayer',
  //         start: 'top top',
  //         endTrigger: '.footer',
  //         end: 'bottom bottom',
  //         pin: '.audioPlayer',
  //         pinSpacer: '.article',
  //         scrub: 1,
  //         id: 'audioPlayingFixed'
  //       }
  //     });
  //   }
  //   if (audioPlayMode && removeGap) {
  //     section2.current.style.zIndex = 2;
  //     if (ScrollTrigger.getById('audioFixed')) {
  //       ScrollTrigger.getById('audioFixed').kill(true);
  //       gsap.set('.article', { clearProps: true });
  //     }
  //     gsap.to('.audioPlayer', {
  //       scrollTrigger: {
  //         trigger: section2.current,
  //         start: 'top bottom',
  //         end: `+=${belowAudioPlayer.current.getBoundingClientRect().height}px`,
  //         pin: '.audioPlayer',
  //         pinSpacer: '.article',
  //         scrub: 1,
  //         id: 'audioPlaying',
  //         toggleActions: 'play pause play reset'
  //       }
  //     });
  //     gsap.to('.audioPlayer', {
  //       scrollTrigger: {
  //         trigger: '.audioPlayer',
  //         start: 'top top',
  //         endTrigger: '.footer',
  //         end: 'bottom bottom',
  //         pinType: 'fixed',
  //         pin: '.audioPlayer',
  //         pinSpacer: '.article',
  //         scrub: 1,
  //         id: 'audioPlayingFixed'
  //       }
  //     });
  //   }
  // }, [audioPlayMode, removeGap]);

  // useEffect(() => {
  //   if (photoSize === 'fullBleed') {
  //     const resizeObserver = new ResizeObserver((entries) => {
  //       const screenHeight = entries[0].contentRect.height;

  //       const section1Height =
  //         belowAudioPlayer.current !== null
  //           ? belowAudioPlayer.current.getBoundingClientRect().height
  //           : null;

  //       if (screenHeight !== currentHeight) {
  //         setCurrentHeight(screenHeight);
  //       }

  //       if (screenHeight > section1Height) {
  //         setRemoveGap(true);
  //       } else {
  //         setRemoveGap(false);
  //       }
  //     });
  //     resizeObserver.observe(screenSizeRef.current);
  //   } else {
  //     setRemoveGap(false);
  //   }
  // }, [currentHeight, photoSize]);

  return (
    <div className="article">
      <div className="height" ref={screenSizeRef} /> {/* to get the screen height */}
      {/* <AudioPlayer audioPlayerRef={audioPlayerRef} audioContainerRef={audioContainerRef} /> */}
      <Header clientName={contents.header} />
      <Hero
        handleMouseEnterTooltip={handleMouseEnterTooltip}
        handleMouseLeaveTooltip={handleMouseLeaveTooltip}
        heroBackgroundType={heroBackgroundType}
        logoPlacement={logoPlacement}
      />
      <Hero2 />
      {/* <div className="article__audioPlayer" /> */}
      {/* <div className="article--belowAudioPlayer" ref={belowAudioPlayer}> */}
      <Chapter1 />
      {/* </div> */}
      <InlinePhoto
        photoSize={photoSize} //this is for Storybook. can be deleted
        photoContents={contents.inlinePhotos.contents[0]} //pass in corresponding data
        photoRef={inline1} //pass in ref
      />
      <Chapter2 />
      <FullWidthPhoto
        photo={fullbleedPhoto1}
        alt={'men on boat on a lake'}
        caption={'© Callum Thompson, Lenovo Work For Humankind'}
      />
      <Chapter3 />
      <InlinePhoto
        photoSize={photoSize} //this is for Storybook. can be deleted
        photoContents={contents.inlinePhotos.contents[1]} //pass in corresponding data
        photoRef={inline2} //pass in ref
      />
      <Chapter4 />
      <InlinePhoto
        photoSize={photoSize} //this is for Storybook. can be deleted
        photoContents={contents.inlinePhotos.contents[2]} //pass in corresponding data
        photoRef={inline3} //pass in ref
      />
      <Chapter5 />
      <InlineVideo
        vidLink={
          'https://courageous-cdn-media-bucket.s3.amazonaws.com/lenovo/Island-Infographic_V2.mp4'
        }
      />
      <Chapter6 />
      <FullWidthVideo
        vidLink={'https://courageous-cdn-media-bucket.s3.amazonaws.com/lenovo/longFilm.mp4'}
      />
      <Chapter7 />
      {/* <CtaButton
        handleMouseEnterTooltip={handleMouseEnterTooltip}
        handleMouseLeaveTooltip={handleMouseLeaveTooltip}
      /> */}
      <div className="article__divider" />
      <Reference />
      <RelatedContents />
      <Footer />
    </div>
  );
}

export default Article;
